/* **The app's one stepper** — a sunken groove holding a minus, a readout and a plus. A stylesheet
 * with no component, the same shape as `segmented` beside it: the two surfaces hang it on different
 * elements (the progression step's readout is an `<output>`, the task kinds' level a text field),
 * so what is shared is the drawing.
 *
 * Promoted out of `features/plan-progression/ui/RuleSentence.module.css` on 2 October 2026, geometry
 * unchanged, on its second consumer — `/zadania/rodzaje`'s level for low sleep and low energy. */

.stepper {
  display: inline-flex;
  gap: var(--space-2px);
  align-items: center;
  height: var(--h-prog-chip);
  padding: var(--space-0) var(--space-1);
  background: var(--bg-inset);
  border: var(--border-hairline) solid var(--border-2);
  border-radius: var(--radius-8px);
}

.button {
  position: relative;
  display: grid;
  place-items: center;
  width: var(--space-5);
  height: var(--space-5);
  font-size: var(--fs-note);
  font-weight: var(--fw-bold);
  color: var(--text-2);
  cursor: pointer;
  user-select: none;
  background: var(--bg-chip);
  border: none;
  border-radius: var(--radius-xs);
}

/* The end is drawn at 18px and pressed at 24: the hit area reaches 3px past the drawing on every
 * side (WCAG 2.5.8), which is the groove's own height, so nothing is redrawn and nothing moves. */
.button::before {
  position: absolute;
  inset: var(--space-minus-3px);
  content: '';
}

.button:focus-visible {
  outline: var(--border-focus) solid var(--focus);
  outline-offset: var(--space-2px);
}

/* A disabled stepper end stays FOCUSABLE and keeps its reason on the accessible name: dropping it
 * out of the tab order hides the very thing that explains why it will not move. */
.button[aria-disabled='true'] {
  color: var(--text-2);
  cursor: default;
  opacity: 0.55;
}

/* The readout reserves its width so the + button does not walk left when "+10 kg" becomes
 * "+1,25 kg". Tabular figures, like every number in this app. */
.value {
  min-width: var(--w-prog-step-readout);
  font-size: var(--fs-note);
  font-weight: var(--fw-bold);
  font-variant-numeric: tabular-nums;
  color: var(--text);
  text-align: center;
}
